<template>
  <lightbox-template :id="id" icon="category-18px" :title="this.$tc('categories.category', 2)">
    <div class="container mb-4">
      <header class="d-flex align-items-center mb-4">
        <h5 class="modal-subtitle">{{ $t('categories.stores.title') }}</h5>
      </header>
    </div>

    <lightbox-skeleton v-if="$_verifyLoaded('loading')" :data="data" :type="type" />
    <tab-item v-if="!loading" :tab-list="tabList" :tab-active="tabTypeActive" />

    <div v-show="$_verifyLoaded('done')" class="col-12">
      <lightbox-table
        :id="id"
        :data="data"
        :data-type="tabTypeActive"
        :is-lightbox-active="isLightboxActive"
        :settings-data="{
          title: `${$t('category')}: ${category}`,
          alt: category,
        }"
        :col-scheme="['chart:percentual', 'revenue']"
      />
    </div>
    <div v-show="$_verifyLoaded('info')" class="card">
      <info-card ref="message-error" :error="hasError" />
    </div>
  </lightbox-template>
</template>

<script>
// @ is an alias to /src
import { getTable } from '@/services/categories';
import bus from '@/helpers/events/bus';
import { lightboxesMixin, verifyMixin, miniBarChartMixin } from '@/helpers/mixins';
import LightboxTemplate from '@/components/lightbox/LightboxTemplate';
import LightboxSkeleton from '@/components/lightbox/lightboxes/categories/LightboxCategoryStoresSkeleton';
import TabItem from '@/components/lightbox/_molecules/_atoms/TabItem';
import LightboxTable from '@/components/lightbox/_molecules/_atoms/LightboxTable';
import InfoCard from '@/components/_atoms/InfoCard';

export default {
  name: 'LightboxCategoryStores',
  components: {
    LightboxTemplate,
    LightboxSkeleton,
    TabItem,
    LightboxTable,
    InfoCard,
  },
  mixins: [lightboxesMixin, miniBarChartMixin, verifyMixin],
  data() {
    return {
      id: 'lightbox-category-stores',
      isLightboxActive: true,
      category: this.$route.params.name,
      data: {
        limit: 10,
        page: 1,
        count: 0,
        values: [],
        valueTotal: 0,
      },
      tabList: [
        {
          name: this.$tc('categories.stores.revenue-orders', 1),
          type: 'highRev',
          color: 'darkblue',
        },
        {
          name: this.$tc('categories.stores.revenue-orders', 2),
          type: 'lowRev',
          color: 'red',
        },
      ],
      tabTypeActive: 'highRev',
      type: 'filled',
    };
  },
  mounted() {
    this.fetchData();

    bus.$on('lightbox-update-tab', item => {
      this.tabTypeActive = item;
      this.data.page = 1; // reset page
      this.$_reqConfig();
      this.updateDataTable();
    });

    bus.$on(`${this.id}-change-page`, () => {
      this.fetchData();
    });
    bus.$on(`${this.id}-change-order`, this.fetchData);
  },
  beforeUnmount() {
    bus.$off(`${this.id}-change-page`);
    bus.$off('lightbox-update-tab');
  },

  methods: {
    fetchData() {
      this.$_reqConfig();
      this.updateDataTable();
    },
    verifyDataPerTab(data) {
      if (this.$_verifyData(data)) return false;
      return true;
    },
    fetchHighRevData() {
      getTable({
        name: this.category,
        table: 'store_revenue',
        limit: this.data.limit,
        page: this.data.page,
      })
        .then(({ data }) => {
          if (!this.verifyDataPerTab(data.data)) return;
          this.data.values = data.data;
          this.data.count = data.total_count;
          this.data.valueTotal = data.value_total;
        })
        .catch(() => {
          this.data.count = 0;
          this.data.values = [];
          this.hasError = true;
          this.$_componentHeight();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchLowRevData() {
      getTable({
        name: this.category,
        table: 'store_revenue',
        order_by: 'revenue',
        limit: this.data.limit,
        page: this.data.page,
      })
        .then(({ data }) => {
          if (!this.verifyDataPerTab(data.data)) return;
          this.data.values = data.data;
          this.data.count = data.total_count;
          this.data.valueTotal = data.value_total;
        })
        .catch(() => {
          this.data.count = 0;
          this.data.values = [];
          this.hasError = true;
          this.$_componentHeight();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateDataTable() {
      switch (this.tabTypeActive) {
        case 'highRev':
          this.fetchHighRevData();
          break;
        case 'lowRev':
          this.fetchLowRevData();
          break;
        default:
          break;
      }
    },
  },
};
</script>
